import { createReducer } from 'deox';
import produce from 'immer';
import { UserState, ProfileState } from './types';
import { getUserAction, updatePasswordAction } from './actions';

const userLocalKey = 'user_data';

// Функция для получения данных пользователя из localStorage при инициализации
const loadUserDataFromLocalStorage = (): ProfileState | null => {
  const userData = localStorage.getItem('user_data');
  return userData ? JSON.parse(userData) : null;
};

// Начальное состояние, включая загрузку данных из localStorage
const initialState: UserState = {
  data: loadUserDataFromLocalStorage(),
  loading: false,
  error: '',
};

export const userReducer = createReducer(initialState, handle => [
  handle(getUserAction.request, state =>
    produce(state, draft => {
      draft.loading = true;
      draft.error = null;
    }),
  ),
  handle(getUserAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.loading = false;
      draft.error = null;
      draft.data = payload.data;
      localStorage.setItem(userLocalKey, JSON.stringify(payload.data));
    }),
  ),
  handle(getUserAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.loading = false;
      draft.error = payload;
    }),
  ),
  handle(updatePasswordAction.request, state =>
    produce(state, draft => {
      draft.loading = true;
      draft.error = null;
    }),
  ),
  // handle(updatePasswordAction.success, (state, { payload }) =>
  //   produce(state, draft => {
  //     draft.loading = false;
  //     draft.error = null;
  //     draft.data = payload;
  //     localStorage.setItem(userLocalKey, JSON.stringify(payload));
  //   }),
  // ),
  handle(updatePasswordAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.loading = false;
      draft.error = payload;
    }),
  ),
]);
